import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import {
  divide,
  FreeBetWinningType,
  toFixed,
  useInputValueChangingFunctions,
} from '@pascal/pascal-core';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';
import { InputTypesForChanging } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { betDataStore, gameStore } from '../../../../store';
import { useAmountValidation } from '../../../../helpers/useAmountValidation';
import { globalTranslationKeys } from '../../../../enums';
import { minOddConstant, minOddStep } from '../../../../enums/gameConstants';
import { CashOutOdd } from '../../../../components/common/bettingPart';

export const AutoCashOut = observer(({ t, handleOpenNumPad }) => {
  const { activeGameType, minOdd } = gameStore;
  const { limits } = gameConfigStore;
  const { autoCashOutToggle, betsSectionsData, setAutoCashOutOdd } = betDataStore;
  const { isAutoCashOut, autoCashOutOdd, isAutoBet, betAmount } = betsSectionsData[activeGameType];
  const { activeFreeBet } = freeBetStore;

  const onChangeAutoCashOutHandler = useCallback((changeValue, activeGameType) => {
    setAutoCashOutOdd(changeValue, activeGameType);
  }, []);

  const { simpleOnChange: onChangeAutoCashOut } = useAmountValidation(onChangeAutoCashOutHandler);
  const freeBetMaxPayOut =
    freeBetStore.activeFreeBet.winType === FreeBetWinningType.Win && activeFreeBet.maxPayout
      ? activeFreeBet.maxPayout + betAmount
      : activeFreeBet.maxPayout;

  const maxWinValue = toFixed(divide(freeBetMaxPayOut || limits.maxWin, betAmount), 2);

  const { handleChangeInputValue } = useInputValueChangingFunctions({
    additionalInputInfo: {
      inputType: InputTypesForChanging.AutoCashOutInput,
      minValue: minOddConstant,
      maxValue: maxWinValue,
    },
    changingValue: autoCashOutOdd,
    changingValueCallback: setAutoCashOutOdd,
    autoCashOutData: {
      isAutoCashOut,
      minOdd: activeFreeBet.id ? activeFreeBet.minOdd : minOdd,
      minOddStep,
      autoCashOutOdd: Number(autoCashOutOdd),
      updateAutoCashOutValue: setAutoCashOutOdd,
    },
    autoCashOutValueChangingCallback: setAutoCashOutOdd,
  });

  return (
    <div className={`bet-cashout-box type${isAutoCashOut ? 1 : 2}`}>
      {isAutoCashOut ? (
        <CashOutOdd
          limits={limits}
          betAmount={betAmount}
          autoCashOutOdd={autoCashOutOdd}
          onChangeAutoCashOut={onChangeAutoCashOut}
          handleAutoCashOutOdd={handleChangeInputValue}
          handleOpenNumPad={handleOpenNumPad}
          isAutoBet={isAutoBet}
          setAutoCashOutOdd={setAutoCashOutOdd}
          activeFreeBet={activeFreeBet}
          maxWinValue={maxWinValue}
        />
      ) : (
        <div className='bet-cashout-text-wrp'>
          <p className='bet-cashout-text'>{t(globalTranslationKeys.AutoCashOut)}</p>
        </div>
      )}
      <div
        className={`switch-box ${isAutoBet ? 'disabled' : ''}`}
        onClick={() => autoCashOutToggle(activeGameType)}
      >
        <div className={`game-switch ${isAutoCashOut ? 'active' : ''}`}>
          <div />
        </div>
      </div>
    </div>
  );
});
